import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { ref, computed, watch, onUnmounted } from 'vue';
export default {
  name: 'EventTooltip',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: null
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    placement: {
      type: String,
      default: 'top'
    }
  },
  emits: ['edit', 'complete', 'delete', 'close'],
  setup(props, {
    emit
  }) {
    const tooltipRef = ref(null);

    // 类型颜色映射
    const typeColors = {
      meeting: '#3B82F6',
      call: '#10B981',
      task: '#F59E0B',
      deadline: '#EF4444',
      other: '#6B7280'
    };

    // 类型标签映射
    const typeLabels = {
      meeting: '会议',
      call: '电话',
      task: '任务',
      deadline: '截止',
      other: '其他'
    };

    // 计算属性
    const typeColor = computed(() => props.event?.color || typeColors[props.event?.type] || typeColors.other);
    const typeLabel = computed(() => typeLabels[props.event?.type] || '日程');
    const formattedTime = computed(() => {
      if (!props.event) return '';
      const {
        time,
        duration
      } = props.event;
      if (!time) return '';
      const [hours, minutes] = time.split(':').map(Number);
      const endMinutes = hours * 60 + minutes + (duration || 0);
      const endHours = Math.floor(endMinutes / 60);
      const endMins = endMinutes % 60;
      const formatTime = (h, m) => {
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      };
      return duration ? `${formatTime(hours, minutes)} - ${formatTime(endHours, endMins)}` : time;
    });

    // 菜单位置
    const tooltipStyle = computed(() => {
      const {
        x,
        y,
        placement
      } = props;
      const tooltip = tooltipRef.value;
      const offset = 12; // 偏移量

      let left = x;
      let top = y;
      if (tooltip) {
        const rect = tooltip.getBoundingClientRect();
        switch (placement) {
          case 'top':
            {
              left = x - rect.width / 2;
              top = y - rect.height - offset;
              break;
            }
          case 'bottom':
            {
              left = x - rect.width / 2;
              top = y + offset;
              break;
            }
          case 'left':
            {
              left = x - rect.width - offset;
              top = y - rect.height / 2;
              break;
            }
          case 'right':
            {
              left = x + offset;
              top = y - rect.height / 2;
              break;
            }
        }

        // 防止超出屏幕
        left = Math.max(10, Math.min(left, window.innerWidth - rect.width - 10));
        top = Math.max(10, Math.min(top, window.innerHeight - rect.height - 10));
      }
      return {
        left: `${left}px`,
        top: `${top}px`
      };
    });

    // 链接类型标签
    function linkLabel(type) {
      const labels = {
        customer: '客户',
        opportunity: '商机',
        contract: '合同',
        project: '项目'
      };
      return labels[type] || type;
    }

    // 处理操作
    function handleEdit() {
      emit('edit', props.event);
    }
    function handleComplete() {
      emit('complete', props.event);
    }
    function handleDelete() {
      emit('delete', props.event);
    }

    // 点击外部关闭
    function handleClickOutside(e) {
      if (props.visible && tooltipRef.value && !tooltipRef.value.contains(e.target)) {
        emit('close');
      }
    }
    watch(() => props.visible, visible => {
      if (visible) {
        document.addEventListener('click', handleClickOutside);
      } else {
        document.removeEventListener('click', handleClickOutside);
      }
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    return {
      tooltipRef,
      typeColor,
      typeLabel,
      formattedTime,
      tooltipStyle,
      linkLabel,
      handleEdit,
      handleComplete,
      handleDelete
    };
  }
};